import { getMarketCollectionPage } from '@/api/market';
import { PAGE_SIZE } from '@/domain/market/feed-query';

/**
 * 执行 POST /liyuan-market/collection/page 单次分页请求（home / explore 等共用）
 * @returns {Promise<{ apiRows: object[], nextPage: number, hasMore: boolean }>}
 */
export async function fetchCollectionPageResult({
  query,
  append,
  pageNum,
  rawRowsLength,
  pageSize = PAGE_SIZE,
}) {
  const nextPage = append ? pageNum + 1 : 1;
  const data = await getMarketCollectionPage(query, {
    pageNum: nextPage,
    pageSize,
  });

  const apiRows = Array.isArray(data?.rows) ? data.rows : [];
  const total = Number(data?.total ?? 0);
  const mergedLength = append ? rawRowsLength + apiRows.length : apiRows.length;

  let hasMore;
  if (apiRows.length < pageSize) {
    hasMore = false;
  } else if (total > 0) {
    hasMore = mergedLength < total;
  } else {
    hasMore = true;
  }

  return { apiRows, nextPage, hasMore };
}
